"use client";

import { Info } from "lucide-react";
import React, { useState, useEffect } from "react";
import useMovementDetection from "@/components/useMouseMovement";
import dynamic from "next/dynamic";
const CustomTooltip = dynamic(() => import("./custom-tooltip").then((mod) => mod.CustomTooltip), {
    ssr: false,
    loading: () => <Info className="fill-c2 text-white cursor-pointer" size={16} />,
});

const CustomTooltipLazyLoad = ({ text }: { text: string }) => {
    const [showLayout, setShowLayout] = useState(false);
    const hasInteracted = useMovementDetection();
    useEffect(() => {
        if (hasInteracted && !showLayout) {
            setShowLayout(true);
        }
    }, [hasInteracted, showLayout]);

    return showLayout ? (
        <CustomTooltip text={text} />
    ) : (
        <Info className="fill-c2 text-white cursor-pointer" size={16} />
    );
};

export default CustomTooltipLazyLoad;
